module.exports = __webpack_public_path__ + "img/Span-05.d7159eb1.jpg";